import { useEffect, useState } from 'react';

import { fetchGeneralSettings, isChatConnected, isTicketConnected } from '@/lib/generalSettingsApi';

/**
 * @param {'chat' | 'ticket'} scope
 * @returns {boolean | null} null while loading
 */
export function usePlatformConnectionMode(scope = 'chat') {
  const [connected, setConnected] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = () => {
      fetchGeneralSettings()
        .then((data) => {
          if (cancelled) return;
          setConnected(scope === 'ticket' ? isTicketConnected(data) : isChatConnected(data));
        })
        .catch(() => {
          if (!cancelled) setConnected(true);
        });
    };

    load();
    window.addEventListener('focus', load);
    window.addEventListener('general-settings-updated', load);
    return () => {
      cancelled = true;
      window.removeEventListener('focus', load);
      window.removeEventListener('general-settings-updated', load);
    };
  }, [scope]);

  return connected;
}
